import type { VehicleShapeDefinition } from './vehicleShape';

/**
 * Wheel loader with front grapple
 * Converted from SVG viewBox (0 0 100 150) to normalized space (0 0 100 100)
 */
export const wheelLoaderFrontGrappleShape: VehicleShapeDefinition = {
  vehicle: 'wheel_loader_front_grapple',
  coordinateSystem: '2D',
  unit: 'normalized_percent',
  polygons: {
    rear_wheel_left: [
      [15, 90],
      [35, 90],
      [35, 130],
      [15, 130],
    ],

    rear_wheel_right: [
      [65, 90],
      [85, 90],
      [85, 130],
      [65, 130],
    ],

    front_wheel_left: [
      [15, 40],
      [35, 40],
      [35, 68],
      [15, 68],
    ],

    front_wheel_right: [
      [65, 40],
      [85, 40],
      [85, 68],
      [65, 68],
    ],

    lower_body: [
      [30, 85],
      [70, 85],
      [70, 140],
      [30, 140],
    ],

    upper_body: [
      [30, 45],
      [70, 45],
      [70, 75],
      [30, 75],
    ],

    driver_cabin: [
      [35, 65],
      [65, 65],
      [65, 105],
      [35, 105],
    ],

    grapple: [
      [10, 35],
      [50, 15],
      [90, 35],
      [50, 29],
    ],
  },
  colorConfig: {
    lower_body: { type: 'dynamic' }, // Uses vehicle color
    upper_body: { type: 'dynamic' }, // Uses vehicle color
    front_wheel_left: { type: 'fixed', color: '#000000' },
    front_wheel_right: { type: 'fixed', color: '#000000' },
    rear_wheel_left: { type: 'fixed', color: '#000000' },
    rear_wheel_right: { type: 'fixed', color: '#000000' },
    driver_cabin: { type: 'fixed', color: '#000000' },
    grapple: { type: 'fixed', color: '#000000' },
  },
};
